module.exports = __webpack_public_path__ + "img/guanzhu.6efb12a7.png";